export function pleitoPostoInRequest(params = {}) {
  return {
    type: '@pleitoposto/PLEITOVEICULO_IN_REQUEST',
    payload: { params },
  };
}

export function findPleitoPosto(idpleito) {
  return {
    type: '@pleitoposto/FIND_PLEITOPOSTO',
    payload: { idpleito },
  };
}

export function failedRequest() {
  return {
    type: '@pleitoposto/FAILED_REQUEST',
  };
}

export function deletePleitoPosto(idpleito, params) {
  return {
    type: '@pleitoposto/DELETE_PLEITOPOSTO',
    payload: { idpleito, params },
  };
}

export function updatePleitoPosto(pleito, params) {
  return {
    type: '@pleitoposto/UPDATE_PLEITOPOSTO',
    payload: { pleito, params },
  };
}

export function storePleitoPosto(pleito, params) {
  return {
    type: '@pleitoposto/STORE_PLEITOPOSTO',
    payload: { pleito, params },
  };
}

export function successInRequest(
  pleitopostos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@pleitoposto/SUCCESS_IN_REQUEST',
    payload: { pleitopostos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(pleitopostos) {
  return {
    type: '@pleitoposto/SUCCESS_REQUEST',
    payload: { pleitopostos },
  };
}

export function successRemove(params) {
  return {
    type: '@pleitoposto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@pleitoposto/RECORD_FILTERING',
    payload: { params },
  };
}
